import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterFunnel = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30 13.5L22 21.5V29.5L18 31.5V21.5L10 13.5V10.5H30V13.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgFilterFunnel);
export default ForwardRef;
